import sharedModule from '../../shared.module';

class DoughnutService {
    constructor(
        alertLevelConstants,
        doughnutColorConstants,
        usageTypeConstants
    ) {
        this.alertLevelConstants = alertLevelConstants;
        this.doughnutColorConstants = doughnutColorConstants;
        this.usageTypeConstants = usageTypeConstants;
    }

    getDoughnutColor(alertLevel, usageType) {
        if (
            alertLevel === this.alertLevelConstants.warning ||
            alertLevel === this.alertLevelConstants.hazard
        ) {
            return this.doughnutColorConstants.yellow;
        } else if (alertLevel === this.alertLevelConstants.critical) {
            return this.doughnutColorConstants.red;
        }

        switch (usageType) {
            case this.usageTypeConstants.platformUser:
            case this.usageTypeConstants.bandwidth:
                return this.doughnutColorConstants.grey;
            default:
                return this.doughnutColorConstants.blue;
        }
    }
}

export default sharedModule.service('doughnutService', DoughnutService);



// WEBPACK FOOTER //
// ./modules/shared/services/doughnut/doughnut.service.js